var map = {
	"./de-CH/storefront-app": [
		31686,
		1686
	],
	"./de-DE/storefront-app": [
		3091,
		3091
	],
	"./en-CH/storefront-app": [
		59721,
		9721
	],
	"./en-GB/storefront-app": [
		81645,
		1645
	],
	"./en-US/storefront-app": [
		99125,
		9125
	],
	"./es-ES/storefront-app": [
		25681,
		5681
	],
	"./fr-CH/storefront-app": [
		84069,
		4069
	],
	"./fr-FR/storefront-app": [
		5147,
		5147
	],
	"./it-CH/storefront-app": [
		31114,
		1114
	],
	"./it-IT/storefront-app": [
		20257,
		257
	],
	"./ja-JP/storefront-app": [
		15869,
		5869
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 7 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 22168;
module.exports = webpackAsyncContext;